import { snakeCase, text, unique } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { accessTypeEnum } from './_common.table'
import { clientsTable } from './clients.table'
import { usersTable } from './users.table'
import { vendorsTable } from './vendors.table'

export const clientVendorAccessTable = snakeCase.table(
    'client_vendor_access',
    {
        id: id('cva'),
        clientId: text()
            .notNull()
            .references(() => clientsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        vendorId: text()
            .notNull()
            .references(() => vendorsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        accessType: accessTypeEnum().notNull(),
        createdByUserId: text().references(() => usersTable.id, {
            onDelete: 'set null',
            onUpdate: 'cascade',
        }),
        ...timestamps,
    },
    (table) => [
        unique('client_vendor_unique').on(table.clientId, table.vendorId),
    ],
)
